import { currentConnectionStatus } from '@canvas/canvas-state';
import { type BaseContext } from '@canvas/state-machine/types';

import { type BoardSyncStateMachineConfig } from './board-sync-state-machine-types';

const noop = () => {};

/** No changes to state machine context required. */
const noChange = (context: BaseContext) => context;

export const createBoardSyncStateMachineConfig = (): BoardSyncStateMachineConfig => ({
  initial: 'unknown',
  states: {
    unknown: {
      transitions: {
        messagesPending: [
          {
            state: 'syncing',
            guard: [],
            context: [noChange],
          },
        ],
        messagesSaved: [
          {
            state: 'synced',
            guard: [],
            context: [noChange],
          },
        ],
        messagesDiscarded: [
          {
            state: 'readOnlyDiscarded',
            guard: [],
            context: [noChange],
          },
        ],
        editToViewAccess: [
          {
            state: 'readOnly',
            guard: [],
            context: [noChange],
          },
        ],
        viewToEditAccess: [
          {
            state: 'edit',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: noop,
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
    synced: {
      transitions: {
        messagesPending: [
          {
            state: 'syncing',
            guard: [],
            context: [noChange],
          },
        ],
        messagesDiscarded: [
          {
            state: 'readOnlyDiscarded',
            guard: [],
            context: [noChange],
          },
        ],
        editToViewAccess: [
          {
            state: 'readOnly',
            guard: [],
            context: [noChange],
          },
        ],
        viewToEditAccess: [
          {
            state: 'edit',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: () => {
          currentConnectionStatus.boardSyncStatus = 'saved';
        },
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
    syncing: {
      transitions: {
        messagesSaved: [
          {
            state: 'synced',
            guard: [],
            context: [noChange],
          },
        ],
        messagesDiscarded: [
          {
            state: 'readOnlyDiscarded',
            guard: [],
            context: [noChange],
          },
        ],
        editToViewAccess: [
          {
            state: 'readOnly',
            guard: [],
            context: [noChange],
          },
        ],
        viewToEditAccess: [
          {
            state: 'edit',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: () => {
          currentConnectionStatus.boardSyncStatus = 'saving';
        },
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
    readOnlyDiscarded: {
      transitions: {
        viewToEditAccess: [
          {
            state: 'edit',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: () => {
          currentConnectionStatus.boardSyncStatus = 'editToViewOfflineChangesDiscarded';
        },
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
    readOnly: {
      transitions: {
        viewToEditAccess: [
          {
            state: 'edit',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: () => {
          currentConnectionStatus.boardSyncStatus = 'editToViewAccess';
        },
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
    edit: {
      transitions: {
        messagesPending: [
          {
            state: 'syncing',
            guard: [],
            context: [noChange],
          },
        ],
        messagesSaved: [
          {
            state: 'synced',
            guard: [],
            context: [noChange],
          },
        ],
        messagesDiscarded: [
          {
            state: 'readOnlyDiscarded',
            guard: [],
            context: [noChange],
          },
        ],
        editToViewAccess: [
          {
            state: 'readOnly',
            guard: [],
            context: [noChange],
          },
        ],
      },
      effects: {
        onEnter: () => {
          currentConnectionStatus.boardSyncStatus = 'viewToEditAccess';
        },
        onExit: noop,
        onReEnter: noop,
        onExecute: noop,
      },
    },
  },
  context: {},
});
